// extracted by mini-css-extract-plugin
export default {"title":"Log_title__R2WVO","subtitle":"Log_subtitle__9y0gI","buttons":"Log_buttons__kqmzS"};